export const SALES_BASE = '/api/admin/v2/sales';

export const salesKeys = {
  all: ['sales'] as const,
  me: () => [...salesKeys.all, 'me'] as const,
  reps: (inactive = false) => [...salesKeys.all, 'reps', { inactive }] as const,
  policy: () => [...salesKeys.all, 'policy'] as const,
  purposes: () => [...salesKeys.all, 'purposes'] as const,
  offers: () => [...salesKeys.all, 'offers'] as const,
  team: () => [...salesKeys.all, 'team'] as const,
  selfCheck: () => [...salesKeys.all, 'self-check'] as const,
  dashboard: (p: unknown = {}) => [...salesKeys.all, 'dashboard', p] as const,
  subjects: (p: unknown = {}) => [...salesKeys.all, 'subjects', p] as const,
  claims: (p: unknown = {}) => [...salesKeys.all, 'claims', p] as const,
  outreach: (p: unknown = {}) => [...salesKeys.all, 'outreach', p] as const,
  search: (p: unknown = {}) => [...salesKeys.all, 'search', p] as const,
  share: (p: unknown = {}) => [...salesKeys.all, 'share', p] as const,
};
